import { ORDER_METHODS } from '../../../../../../../services/exports/Constants';

export default {
  order_methods: {
    delivery: 'Dostawa',
    pickup: 'Odbiór',
    room_service: 'Na miejscu',
    table_service: 'Na miejscu',
  },
  asap: 'ASAP',
  unavailable: 'Niedostępne',
  ready_in_time: 'Gotowe za {{time}} min',
  locations: {
    [ORDER_METHODS.DELIVERY]: 'Dostawa do {{address}}',
    [ORDER_METHODS.PICKUP]: 'Odbiór w {{address}}',
    [ORDER_METHODS.ROOM_SERVICE]: 'Na miejscu w {{address}}',
  },
  buttons: {
    change: 'Zmień',
    see_hours: 'Zobacz godziny',
    change_location: 'Zmień lokalizację',
    change_time: 'Zmień godzinę',
  },
};
